"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UITextInput = _interopRequireDefault(require("../input/UITextInput"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _MeasureText = require("../utils/MeasureText");

var _decorators = require("../utils/propTypes/decorators");

var _Functions = require("../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _FieldsetContext = require("../context/FieldsetContext");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var getMinimumSearchMessage = function getMinimumSearchMessage(minimumSearchCount, value) {
  var valueLength = value ? value.length : 0;
  var charsNeeded = minimumSearchCount - valueLength;

  if (valueLength && charsNeeded > 0) {
    return _I18n.default.text('salesUI.UISearchInput.minimumSearchMessage', {
      count: charsNeeded
    });
  }

  return null;
};

var UISearchInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UISearchInput, _PureComponent);

  function UISearchInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UISearchInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UISearchInput).call(this, props));
    _this.state = {
      minimumSearchMessageOverflows: false
    };
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.triggerClear = _this.triggerClear.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UISearchInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var minimumSearchCount = this.props.minimumSearchCount;
      if (minimumSearchCount > 0) this.computeMinimumSearchMessageOverflow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var minimumSearchCount = this.props.minimumSearchCount;
      if (minimumSearchCount > 0) this.computeMinimumSearchMessageOverflow();
    }
  }, {
    key: "computeMinimumSearchMessageOverflow",
    value: function computeMinimumSearchMessageOverflow() {
      // Determine whether there's enough space to show the minimum search message inline (#2869)
      var inputRef = this.props.inputRef;
      if (!this._wrapperEl || !this._iconEl || !this._helpTextEl) return;
      var wrapperWidth = this._wrapperEl.offsetWidth - this._iconEl.offsetWidth;
      var searchMessageWidth = this._helpTextEl.offsetWidth;
      var textWidth = (0, _MeasureText.getTextWidth)(inputRef.current);
      var minimumSearchMessageOverflows = searchMessageWidth > wrapperWidth - textWidth;

      if (minimumSearchMessageOverflows !== this.state.minimumSearchMessageOverflows) {
        this.setState({
          minimumSearchMessageOverflows: minimumSearchMessageOverflows
        });
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(evt) {
      var _this$props = this.props,
          onKeyDown = _this$props.onKeyDown,
          readOnly = _this$props.readOnly;
      if (readOnly) return;

      if (evt.key === 'Escape') {
        this.triggerClear();
      }

      (0, _Functions.callIfPossible)(onKeyDown, evt);
    }
  }, {
    key: "triggerClear",
    value: function triggerClear() {
      var _this$props2 = this.props,
          inputRef = _this$props2.inputRef,
          onChange = _this$props2.onChange;
      onChange((0, _SyntheticEvent.default)(''));
      inputRef.current.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          clearable = _this$props3.clearable,
          icon = _this$props3.icon,
          inputClassName = _this$props3.inputClassName,
          minimumSearchCount = _this$props3.minimumSearchCount,
          placeholder = _this$props3.placeholder,
          readOnly = _this$props3.readOnly,
          size = _this$props3.size,
          value = _this$props3.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["className", "clearable", "icon", "inputClassName", "minimumSearchCount", "placeholder", "readOnly", "size", "value"]);
      var minimumSearchMessageOverflows = this.state.minimumSearchMessageOverflows;
      return _react.default.createElement(_FieldsetContext.FieldsetContextConsumer, null, function (fieldsetContext) {
        var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
        var computedClassName = (0, _classNames.default)('private-search-control', {
          'private-search-control--xl': longhandSize === 'extra-large'
        }, className);
        var showClearButton = clearable && value && !readOnly;
        var minimumSearchMessage = getMinimumSearchMessage(minimumSearchCount, value);
        var renderedMinimumSearchMessage = minimumSearchMessage ? _react.default.createElement("span", {
          "aria-atomic": false,
          "aria-live": "polite",
          className: (0, _classNames.default)('private-search-control__help-text', {
            'private-search-control__help-text--hidden': minimumSearchMessageOverflows
          }),
          ref: function ref(_ref) {
            _this2._helpTextEl = _ref;
          }
        }, minimumSearchMessage) : null;
        var renderedSearchIcon = icon && !readOnly ? _react.default.createElement(_UIIcon.default, {
          className: (0, _classNames.default)('private-search-control__icon', {
            'private-search-control__icon--small': fieldsetContext.size === 'small',
            'private-search-control__icon--hidden': showClearButton
          }),
          name: "search",
          ref: function ref(_ref2) {
            _this2._iconEl = (0, _reactDom.findDOMNode)(_ref2);
          }
        }) : null;
        var renderedClearButton = showClearButton ? _react.default.createElement(_UIClickable.default, {
          className: (0, _classNames.default)('private-search-control__clear-button', {
            'private-search-control__clear-button--small': fieldsetContext.size === 'small'
          }),
          onClick: _this2.triggerClear,
          tabIndex: -1
        }, _react.default.createElement(_UIIcon.default, {
          name: "remove"
        })) : null;
        return _react.default.createElement(_UITooltip.default, {
          open: !!(minimumSearchMessage && minimumSearchMessageOverflows),
          title: minimumSearchMessage
        }, _react.default.createElement("div", {
          className: computedClassName,
          ref: function ref(_ref3) {
            _this2._wrapperEl = _ref3;
          }
        }, _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, rest, {
          className: (0, _classNames.default)('private-search-control__input', inputClassName),
          onKeyDown: _this2.handleKeyDown,
          placeholder: (0, _lazyEval.default)(placeholder),
          readOnly: readOnly,
          value: value
        })), _react.default.createElement("span", {
          className: "private-search-control__foreground"
        }, renderedMinimumSearchMessage, renderedSearchIcon), renderedClearButton));
      });
    }
  }]);
  return UISearchInput;
}(_react.PureComponent);

UISearchInput.propTypes = (0, _extends2.default)({}, _UITextInput.default.propTypes, {
  clearable: _react.PropTypes.bool.isRequired,
  icon: _react.PropTypes.bool.isRequired,
  inputClassName: _react.PropTypes.string,
  minimumSearchCount: _react.PropTypes.number.isRequired,
  size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['xl']), _react.PropTypes.oneOf(['default'])]).isRequired,
  type: (0, _decorators.hidden)(_UITextInput.default.propTypes.type)
});
UISearchInput.defaultProps = (0, _extends2.default)({}, _UITextInput.default.defaultProps, {
  clearable: true,
  icon: true,
  minimumSearchCount: 0,
  placeholder: function placeholder() {
    return _I18n.default.text('salesUI.UISearchInput.placeholder');
  },
  size: 'default',
  type: 'search',
  value: ''
});
UISearchInput.displayName = 'UISearchInput';

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UISearchInput));

exports.default = _default;
module.exports = exports.default;